"use client";

import BecomePartner from "@/views/partner";

export default function Page() {
  return <BecomePartner />;
}
